/**
 * 결제 완료 화면용 쿠폰 금액 임시 보관 — 결제창 이동 직전 prepare 응답(정가·할인·쿠폰명)을 주문별로 sessionStorage 에 둔다.
 * 서버 confirm 응답에 같은 값이 있으면 그쪽을 우선한다. 저장소를 못 쓰면(사생활 보호 모드 등) 조용히 건너뛴다.
 */

export interface PaymentCouponSnapshot {
    listAmount: number;
    discountAmount: number;
    couponName: string | null;
}

const KEY_PREFIX: string = 'seminarPaymentCoupon:';

export const stashPaymentCoupon = (orderId: string, snapshot: PaymentCouponSnapshot): void => {
    try {
        window.sessionStorage.setItem(`${KEY_PREFIX}${orderId}`, JSON.stringify(snapshot));
    } catch {
        // 저장 실패 — 결제 완료 화면은 결제 금액만 보여 준다
    }
};

export const readPaymentCoupon = (orderId: string | null): PaymentCouponSnapshot | null => {
    if (!orderId) return null;
    try {
        const raw: string | null = window.sessionStorage.getItem(`${KEY_PREFIX}${orderId}`);
        return raw ? (JSON.parse(raw) as PaymentCouponSnapshot) : null;
    } catch {
        return null;
    }
};
